/*
 * df-teeinblue-coords.js
 *
 * Sincroniza coordenadas geográficas desde los inputs "maps" de Teeinblue
 * hacia inputs de texto pareados, redondeando a 7 decimales.
 *
 * SYNC WITH TEEINBLUE DASHBOARD — si añades o cambias capas en Teeinblue,
 * actualiza el array LAYERS de abajo. Los IDs corresponden a campos
 * configurados en la app Teeinblue (Spain + Portugal).
 */
(function () {
  'use strict';

  var LAYERS = [
    // ES
    { input: 'layer-749547', output: 'layer-465952', last: '' },
    { input: 'layer-719732', output: 'layer-872518', last: '' },
    { input: 'layer-498239', output: 'layer-154757', last: '' },
    // PT
    { input: 'layer-722504', output: 'layer-401277', last: '' },
    { input: 'layer-571650', output: 'layer-558047', last: '' },
    { input: 'layer-904686', output: 'layer-291938', last: '' }
  ];

  var COORD_REGEX = /[-+]?[0-9]*\.?[0-9]+,?\s*[-+]?[0-9]*\.?[0-9]+/;
  var POLL_MS = 500;
  var BOOT_POLL_MS = 300;
  var BOOT_MAX_TRIES = 30;

  function readMapText(layerId) {
    var host = document.getElementById('tee-field--' + layerId);
    if (!host) return '';
    var node = host.querySelector('.tee-field__input .tee-field-maps-name');
    return node ? node.textContent : '';
  }

  function writeOutput(outputId, value) {
    var el = document.getElementById(outputId);
    if (!el) return false;
    el.value = value;
    el.dispatchEvent(new Event('input', { bubbles: true }));
    return true;
  }

  function syncLayer(layer) {
    var raw = readMapText(layer.input);
    if (!raw) return;

    var match = raw.match(COORD_REGEX);
    if (!match) return;

    var parts = match[0].split(',').map(function (n) { return n.trim(); });
    if (parts.length < 2) return;

    var formatted = parts
      .map(function (n) { return (Number(n) || 0).toFixed(7).slice(0, 9); })
      .join(' , ');

    if (formatted === layer.last) return;
    if (!writeOutput(layer.output, formatted)) return;
    layer.last = formatted;
  }

  function start() {
    setInterval(function () {
      for (var i = 0; i < LAYERS.length; i++) syncLayer(LAYERS[i]);
    }, POLL_MS);
  }

  function waitForForm() {
    var tries = 0;
    var iv = setInterval(function () {
      if (document.getElementById('tee-artwork-form')) {
        clearInterval(iv);
        start();
        return;
      }
      if (++tries >= BOOT_MAX_TRIES) clearInterval(iv);
    }, BOOT_POLL_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForForm);
  } else {
    waitForForm();
  }
})();
